import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { adminGuard } from './core/auth/admin.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component')
      .then(m => m.LoginComponent)
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./features/auth/unauthorized/unauthorized.component')
      .then(m => m.UnauthorizedComponent)
  },
  {
    path: '',
    loadComponent: () => import('./layouts/main-layout.component')
      .then(m => m.MainLayoutComponent),
    canActivate: [authGuard, adminGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component')
          .then(m => m.DashboardComponent)
      },
      {
        path: 'products',
        loadChildren: () => import('./features/products/products.routes')
          .then(m => m.PRODUCTS_ROUTES)
      },
      {
        path: 'orders',
        loadChildren: () => import('./features/orders/orders.routes')
          .then(m => m.ORDERS_ROUTES)
      },
      {
        path: 'customers',
        loadChildren: () => import('./features/customers/customers.routes')
          .then(m => m.CUSTOMERS_ROUTES)
      },
      {
        path: 'emails',
        loadChildren: () => import('./features/emails/emails.routes')
          .then(m => m.EMAILS_ROUTES)
      },
      {
        path: 'config/collections',
        loadChildren: () => import('./features/collections/collections.routes')
          .then(m => m.COLLECTIONS_ROUTES)
      },
      {
        path: 'config/room-types',
        loadChildren: () => import('./features/room-types/room-types.routes')
          .then(m => m.ROOM_TYPES_ROUTES)
      },
      {
        path: 'config/rug-models',
        loadChildren: () => import('./features/rug-models/rug-models.routes')
          .then(m => m.RUG_MODELS_ROUTES)
      },
      {
        path: 'config/edge-finishes',
        loadChildren: () => import('./features/edge-finishes/edge-finishes.routes')
          .then(m => m.EDGE_FINISHES_ROUTES)
      },
      {
        path: 'config/size-variants',
        loadChildren: () => import('./features/size-variants/size-variants.routes')
          .then(m => m.SIZE_VARIANTS_ROUTES)
      },
      {
        path: 'config/countries',
        loadChildren: () => import('./features/countries/countries.routes')
          .then(m => m.COUNTRIES_ROUTES)
      },
      {
        path: 'config/aspect-ratios',
        loadChildren: () => import('./features/aspect-ratios/aspect-ratios.routes')
          .then(m => m.ASPECT_RATIOS_ROUTES)
      },
      {
        path: 'import',
        loadChildren: () => import('./features/import/import.routes')
          .then(m => m.IMPORT_ROUTES)
      },
      {
        path: 'reports',
        loadChildren: () => import('./features/reports/reports.routes')
          .then(m => m.REPORTS_ROUTES)
      },
      {
        path: 'demo/page-header',
        loadComponent: () => import('./shared/components/page-header/page-header-demo.component')
          .then(m => m.PageHeaderDemoComponent)
      },
      {
        path: 'demo/loading-spinner',
        loadComponent: () => import('./shared/components/loading-spinner/loading-spinner-demo.component')
          .then(m => m.LoadingSpinnerDemoComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
